import { Component, OnInit } from '@angular/core';
import { DatabaseService } from '../providers/database.service';
import { AuthService } from '../providers/auth.service';

@Component({
  selector: 'app-connect',
  templateUrl: './connect.component.html',
  styleUrls: ['./connect.component.css']
})
export class ConnectComponent implements OnInit {

  url: string = "";
  name: string = "";
  type = "Stream Type";

  streamInfo = {
    url: '',
    name: '',
    peerName: this.authService.displayName,
    peerEmail: this.authService.email,
    type: ''
  };

  constructor(public databaseService: DatabaseService, public authService: AuthService) { }

  ngOnInit() {
  }

  startPlay() {
    this.streamInfo.name = this.name;
    this.streamInfo.url = this.url;  
    this.streamInfo.type = this.type;  
  }

  setType(o: any) {
    this.type = o;
  }

  onSubmit() {
    console.log(this.name + " at " + this.url);
    var streamInfo = {
      'url': this.url,
      'name': this.name,
      'peerName': this.authService.displayName,
      'peerEmail': this.authService.email,
      'type': this.type
    };
    this.databaseService.addStream(streamInfo);
  }
}



// WEBPACK FOOTER //
// /var/www/html/mediate/src/app/connect/connect.component.ts